<template>
    <div
        class="slt-max-content-center slt-gsap-awards slt-padding-box flex flex-col gap-12 pb-10 sm:gap-[72px] sm:pb-20 lg:gap-[112px] lg:pb-40"
    >
        <AtomsH2 v-if="shouldRender(awards?.title)">
            <BaseFormatText2
                ref="titleText"
                :text="awards?.title"
                type="span"
            />
        </AtomsH2>
        <div
            class="grid w-full grid-cols-1 gap-4 sm:w-fit sm:grid-cols-2 sm:gap-16 lg:mx-auto lg:gap-x-[112px] lg:gap-y-[172px]"
        >
            <!-- Slice the first 3 awards(only 3 awards are allowed to be displayed) -->
            <MoleculesAward
                v-for="(award, idx) in awards?.data?.slice(0, 3)"
                :key="idx"
                :award="award"
                class="h-fit sm:row-span-2 sm:w-[39.06vw] lg:w-[37.7vw] 3xl:w-[693.3px]"
                :class="idx === 1 ? 'sm:col-start-2 sm:row-start-2' : ''"
            />
        </div>
        <MoleculesButtonLink
            class="sm:mt-4 lg:mt-0"
            to="/awards"
            v-if="shouldRender(awards?.button)"
            v-sendGAsignal="{
                event_category: 'about.awards',
                event_label: awards?.button,
            }"
        >
            {{ awards?.button }}
        </MoleculesButtonLink>
    </div>
</template>

<script setup>
import { useGtag } from "vue-gtag-next";
import { shouldRender } from "~/lib/utils";
import { organismAwardsAnimate } from "@/lib/gsap-about";
import { textSplitAnimate, killAnimation } from "@/lib/gsap-core";
const { awards } = defineProps({
    awards: {
        type: Object,
        required: true,
    },
});
const { event } = useGtag();

const titleText = ref(null);
let tl = null;
onMounted(() => {
    tl = organismAwardsAnimate(
        () => textSplitAnimate(false, titleText, 0.5),
        () =>
            event("user_engagement", {
                event_category: "about",
                event_label: "獲獎紀錄",
            }),
    );
});
onBeforeUnmount(() => {
    killAnimation(tl);
});
</script>
